import { Component, Injector, Input, OnInit } from '@angular/core';
import { StatisticsService } from 'bookraw/shared/services/statistics.service';
import { DatePipe } from 'bookraw/shared/pipes/date.pipe';
import { SchoolClass } from 'bookraw/shared/models/school-class.model';
import { HttpErrorResponse } from '@angular/common/http';
import { showErrorMessage } from 'bookraw/shared/helpers/errorHelper';
import { BookrawAppModule } from 'bookraw/app.module';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-goal-settings',
  templateUrl: './goal-settings.component.html',
  styleUrls: ['./goal-settings.component.scss'],
  providers: [DatePipe],
})
export class GoalSettingsComponent implements OnInit {
  @Input() booksByLevel: number;
  @Input() type: any = '';

  @Input() entityId: number = 0;
  @Input() schoolClasses: SchoolClass[] = [];

  goalMinute: number = 0;
  schoolClassList: SchoolClass[] = [];
  month: any[] = [];
  filterStatSchoolClass: number;
  protected readonly loaderService: AppLoaderService;

  constructor(
    public service: StatisticsService,
    public injector: Injector,
    public translate: TranslateService
  ) {
    this.loaderService = BookrawAppModule.injector.get(AppLoaderService);
  }


  ngOnInit() {
    this.getGoalMinute();
  }

  saveGoalMinute(reset: boolean = false) {
    this.loaderService.open( this.translate.instant('general.in_progress') );
    this.setQueryParams(true, reset);
    this.service.updateReadGoalStat().subscribe(
      (data) => {
        this.goalMinute = data.result / 60;
        this.service.goalSettingsChanged.emit();
        this.loaderService.close();
      },
      (error) => {
        this.handleError(error);
      }
    );
  }

  private setQueryParams(forUpdate: boolean = false, reset: boolean = false) {
    // Ha van beállítva class akkor csak azokra a gyerekekre küldjük el a célt
    // egyébként az összes gyerekre küldjük el a célt aki az adott iskolában van
    this.service.resetQueryParams('readTimeGoal');
    if (!reset && forUpdate) {
      this.service.setQueryParam('readTimeGoal', (this.goalMinute * 60).toString(), 'readTimeGoal');
    }

    if (this.filterStatSchoolClass && this.type === 'school') {
      this.service.setQueryParam('filters[schoolClassId]', this.filterStatSchoolClass.toString(), 'readTimeGoal');
    }

    if (this.type === 'student') {
      this.service.setQueryParam('filters[userId]', this.entityId.toString(), 'readTimeGoal');
    }
  }

  getGoalMinute() {
    this.setQueryParams();
    this.service.getReadTimeGoal().subscribe(
      (data) => {
        this.goalMinute = data.result.daily / 60;
      },
      (error) => {
        this.handleError(error);
      }
    )
  }

  protected handleError(httpError: HttpErrorResponse) {
    this.loaderService.close();
    showErrorMessage(httpError);
  }
}
